// extracted by mini-css-extract-plugin
export default {"tabsContainer":"LanguageCurrencySelectModal_tabsContainer__p3KmE","buttonsContainer":"LanguageCurrencySelectModal_buttonsContainer__8ZCkU"};